import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import Header from '../components/header/header'
import Loader from '../pages/Loader/loader'


function Parentlayout() {
    return (
        <>
        <Loader>
        <Header/>
        <Outlet/>
        </Loader>
        </>
    )
}

export default Parentlayout
